import { render, staticRenderFns } from "./AddClassification.vue?vue&type=template&id=689773b6&scoped=true&"
import script from "./AddClassification.vue?vue&type=script&lang=js&"
export * from "./AddClassification.vue?vue&type=script&lang=js&"
import style0 from "./AddClassification.vue?vue&type=style&index=0&id=689773b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689773b6",
  null
  
)

export default component.exports